export default __webpack_public_path__ + "static/media/background2.e2a698b0.png";